var VrScrollDownBtn = function(params){
    var _this = this,
        _btnSel = '.js-vr-scroll-dwn-btn';

    function _handleClicks(){
        var scrollMinus = window.innerHeight * .2;
        $(document).on('click touchstart', _btnSel, function(){
            $('html, body').animate({
                scrollTop: window.innerHeight > scrollMinus ? window.innerHeight - scrollMinus : window.innerHeight,
            }, 500, 'swing', function(){
                // $(_btnSel).remove();
                ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'go-down-icon-click');
            });
        });
    }

    function _init(){
        _handleClicks();
    }

    _init();

    _this.init = _init;
};